/**
 * BooleanField for SchemaForm — renders a JSON-Schema `boolean` property as a checkbox.
 */

import { useFormContext, type FieldValues } from 'react-hook-form';
import styles from '../SchemaForm.module.css';
import type { SchemaFieldProps } from './TextField';

export function BooleanField({ name, sub }: SchemaFieldProps) {
  const { register } = useFormContext<FieldValues>();
  return (
    <label className={styles.checkbox}>
      <input type="checkbox" {...register(name)} aria-label={name} />
      <span>{name}</span>
      {sub.description && <small>{sub.description}</small>}
    </label>
  );
}
